module.exports = __webpack_public_path__ + "static/img/详情页设计.fc8fc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/详情页设计.png
// module id = tkfl
// module chunks = 1